import script from "./InspectionPointView.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionPointView.vue?vue&type=script&setup=true&lang=js"

import "./InspectionPointView.vue?vue&type=style&index=0&id=46250e23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46250e23"]])

export default __exports__